import { render, staticRenderFns } from "./InfoBoxes.vue?vue&type=template&id=05b33288&scoped=true&"
import script from "./InfoBoxes.vue?vue&type=script&lang=js&"
export * from "./InfoBoxes.vue?vue&type=script&lang=js&"
import style0 from "./InfoBoxes.vue?vue&type=style&index=0&id=05b33288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b33288",
  null
  
)

export default component.exports